/**
 * Utility methods for manipulating <select></select> control options and values.
 * 
 * @since 1.0.0
 * @package dealerkit-wp
 */
export class SelectBoxUtils 
{
    constructor(document) {
        this.document = document
    }

    addOption(el, label, value, count = null) {
        let option = this.document.createElement('option')
        option.setAttribute('value', value)
        option.innerHTML = label + (count ? ' (' + count + ')' : '')
        el.appendChild(option)
    }

    removeOptions(el) {
        el.querySelectorAll('option').forEach(e => {
            e.remove()
        })
    }

    setOption(el, value) {
        const option = el.querySelector('option[value="' + value + '"]')

        if (option) {
            option.setAttribute('selected', 'selected')
        }
    }
}